import { render, staticRenderFns } from "./MessageTraffic.vue?vue&type=template&id=301d5b13&scoped=true"
import script from "./MessageTraffic.vue?vue&type=script&lang=js"
export * from "./MessageTraffic.vue?vue&type=script&lang=js"
import style0 from "./MessageTraffic.vue?vue&type=style&index=0&id=301d5b13&prod&lang=scss"
import style1 from "./MessageTraffic.vue?vue&type=style&index=1&id=301d5b13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d5b13",
  null
  
)

export default component.exports